/* eslint-disable camelcase */
import { URL_ROUTES } from '@/constants';
import {
  BuyNowEventInteractiveActions,
  BuyNowEventInteractiveCategories,
  BuyNowEventInteractiveTags,
  EEventName
} from '@/modules/shared/utils/gtmEvents/buyNowTypes';

export const baseEvent = {
  'event-interactive-category': BuyNowEventInteractiveCategories.FastCheckout,
  'event-interactive-accion': BuyNowEventInteractiveActions.Clic,
  'event-interactive-tag': BuyNowEventInteractiveTags.PayButton,
  event: EEventName.EVENT_INTERACTIVE
};

export const pageEvent = {
  page: URL_ROUTES.BUY_NOW,
  pagename: 'fast checkout',
  event: EEventName.PAGE_VIRTUAL
};

// Specific for ecommerce events
export const specificEvents = {
  begin_checkout: {
    event: EEventName.BEGIN_CHECKOUT
  },
  add_shipping_info: {
    event: EEventName.ADD_SHIPPING_INFO
  },
  add_payment_info: {
    event: EEventName.ADD_PAYMENT_INFO
  },
  purchase: {
    event: EEventName.PURCHASE
  },
  error: {
    event: EEventName.ERROR,
    'event-interactive-category': BuyNowEventInteractiveCategories.Error,
    'event-interactive-accion': 'fast checkout'
  }
};

export const buyNowEvents = {
  baseEvent,
  pageEvent,
  ...specificEvents
};

export default buyNowEvents;
